var render, staticRenderFns
import script from "./table-with-pagination.vue?vue&type=script&lang=js"
export * from "./table-with-pagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d821f0a')) {
      api.createRecord('3d821f0a', component.options)
    } else {
      api.reload('3d821f0a', component.options)
    }
    
  }
}
component.options.__file = "resources/assets/js/components/table-with-pagination.vue"
export default component.exports